import store from "../../store";
import * as LocaleUtils from "./LocaleUtils";
import * as EnvironmentUtils from "./EnvironmentUtils";
import * as AuthUtils from "./AuthUtils";
import { isFiveKeysTheme } from "./ThemeUtils";
import * as Utils from "./Utils";
import * as GlobalActions from "../../store/Global/Global.action";
import { User } from "../types/UserTypes";

export const isSupportDisabled = () => {
	return document.body.classList.contains("--no-support");
};

export const toggleSupport = (support?: boolean) => {
	document.body.classList.toggle("--no-support", support);
};

export async function openFAQ() {
	store.dispatch(
		GlobalActions.updateLoadingOverlay({
			visible: true,
			message: "%misc_opening_faq",
		}),
	);
	const token = await AuthUtils.refreshAuthToken();
	window.open(
		`${EnvironmentUtils.getBaseUrl()}/misc/faq?token=${encodeURIComponent(
			token,
		)}&locale=${LocaleUtils.getState().code}&redirect=true&variant=${
			isFiveKeysTheme() ? "5keysengage" : "brightmile"
		}`,
		"_blank",
	);
	store.dispatch(
		GlobalActions.updateLoadingOverlay({
			visible: false,
		}),
	);
}

declare const window: any;

let hubspotApi: any = null;
const hubspotPromise = new Promise<void>((resolve, reject) => {
	const timeout = setTimeout(
		() => reject(new Error("Hubspot failed to load in time")),
		20 * 1000,
	);
	window.hsConversationsOnReady = [
		() => {
			clearTimeout(timeout);
			hubspotApi = window.HubSpotConversations;
			resolve();
		},
	];
});

export const getHubspotApi = async () => {
	if (hubspotApi) return hubspotApi;
	return hubspotPromise;
};

const checkWidgetReady = async () => {
	const hsApi = await getHubspotApi();
	if (hsApi?.widget) hsApi.widget.load();
};

export const loadSupportWidget = async (opts: any = {}) => {
	const api = await getHubspotApi();
	const { waitFor } = opts;

	if (!api?.widget) {
		const widgetReady = await checkWidgetReady();
		await Utils.waitFor(() => widgetReady, 50, waitFor || 5000);
	} else {
		api.widget.load();
	}
};

export const contactSupport = async (
	notes?: string,
	opts: any = {},
	callback: null | (() => void) = null,
) => {
	try {
		const api = await getHubspotApi();
		const status = api.widget.status();
		const { waitTime } = opts;

		if (status.loaded) {
			api.widget.open();
		} else {
			const checkOpenReady = () => {
				const status = api.widget.status();

				if (status.loaded) {
					api.widget.open();

					if (callback) {
						callback.call(null);
					}
				}

				return status.loaded;
			};

			await Utils.waitFor(checkOpenReady, 50, waitTime || 3000);
		}
	} catch (error) {
		const { noRedirect } = opts;
		console.error("Obtaining hubspot API failed", error);

		if (!noRedirect) {
			window.location.href = getSupportMailToLink();
		}
	}
};

export const getSupportMailToLink = () => {
	return `mailto:${SUPPORT_EMAIL}`;
};

export const setHubspotIdentity = async (user: User) => {
	try {
		const api = await getHubspotApi();

		const _hsq = (window._hsq = window._hsq || []);

		const item = [
			"identify",
			{
				email: user.email,
				firstName: user.firstName,
				lastName: user.lastName,
				company: `${user.fleetId} - ${user.group}`,
			},
		];

		_hsq.push(item);
		_hsq.push(["trackPageView"]);

		setTimeout(() => {
			api.widget.refresh();
		}, 1000);
	} catch (error) {
		console.error("Error setting HubSpot identity:", error);
	}
};

export const SUPPORT_EMAIL = "support@brightmile.io";
